// Module
var code = `<h2 class="section-header">SSS pension file upload history</h2>
  <table class="table" at-table at-list="\$ctrl.summary">
    <thead></thead>
    <tbody class="tbody">
    <tr class="products-table__row">
      <td at-title="File id">{{item.fileId}}</td>
      <td at-title="Status">Success</td>
      <td at-title="Crediting month">{{item.file.creditingMonthYear || "-"}}</td>
      <td at-title="Uploaded on">{{item.file.uploadedOn | prettyDateTime}}</td>
      <td at-title="Uploaded by">{{\$ctrl.formatUser(item.file.uploadedBy)}}</td>
      <td at-title="File name">{{item.fileMetadata.fileName}}</td>
      <td at-title="File size">{{item.fileMetadata.fileSizeInBytes}} B</td>
      <td at-title="Rows count">{{item.rowsCount}}</td>
      <td>
        <button
          class="btn btn-primary"
          ng-click="\$ctrl.seeDetails(item)">
          Details
        </button>
      </td>
    </tr>
    </tbody>
  </table>

  <div ng-if="!\$ctrl.summary || !\$ctrl.summary.length" class="empty-message">
    <span>SSS pension upload history is blank</span>
  </div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/batch/sss-pension/batch-sss-pension-result-list.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;